<template>
    <div class="summary md:flex md:flex-col md:justify-center pb-0 md:pb-48">
        <div class="summary_menu z-10 relative flex flex-col md:flex-row">
            <div class="max-w-screen-6xl _md:container w-full md:mx-auto z-10 relative flex flex-col md:flex-row">
                <div class="summary_left_content flex items-end flex-col justify-between pr-4 md:pr-0">
                    <div class="summary_logo">
                    </div>
                    <div class="block pr-4 md:pr-0 md:hidden summary_text">
                        <template v-for="content in $t('summary').getSummaryContent()">
                            <p class="text-2xl md:text-sm xl:text-2xl font-bold tracking-wide uppercase" :key="content.text_001" v-html="content.text_001"></p>
                            <p class="text-xs pl-2 whitespace-nowrap tracking-wide" :key="content.text_002" v-html="content.text_002"></p>
                        </template>
                    </div>
                </div>
                <div class="summary_boxes relative w-full flex justify-center flex-wrap gap-x-4 bg-white md:self-end md:justify-start md:gap-x-0">
                    <template v-for="summary in $t('summary').getAll()">
                        <component :is="summary.component" :summary="summary" :key="summary.id"></component>
                    </template>
                    <div class="summary_lines_mobile w-full absolute top-negative_summary_line_height left-0 md:hidden">
                        <!-- <img class="w-full h-full" src="fr/images/summary/summary-lines.png" alt="" /> -->
                        <!-- Folosim linii pana primim imagine de calitate -->
                        <div class="line w-full h-1 mt-2 bg-line"></div>
                        <div class="line w-full h-1 mt-2 bg-line"></div>
                        <div class="line w-full h-1 mt-2 bg-line"></div>
                        <div class="line w-full h-1 mt-2 bg-line"></div>
                        <div class="line w-full h-1 mt-2 bg-line"></div>
                    </div>
                </div>
                <div class="summary_right_content"></div>
            </div>

            <div class="summary_lines w-full hidden absolute bottom-0 left-0 md:block">
                <!-- <img class="w-full h-full" src="fr/images/summary/summary-lines.png" alt="" /> -->
                <!-- Folosim linii pana primim imagine de calitate -->
                <div class="line w-full h-1 mt-2 bg-line"></div>
                <div class="line w-full h-1 mt-2 bg-line"></div>
                <div class="line w-full h-1 mt-2 bg-line"></div>
                <div class="line w-full h-1 mt-2 bg-line"></div>
                <div class="line w-full h-1 mt-2 bg-line"></div>
            </div>
        </div>
        <div class="summary_bg z-0 w-full bg-repeat-x bg-cover md:bg-contain bg-center h-20 md:h-72 md:absolute md:bottom-0 md:left-0" :style="{ backgroundImage: 'url(fr/images/summary/summary-bg.jpg)'}"></div>
        
        <div class="absolute bottom-0 w-full h-10 bg-cornflower_blue" @click="openModal()">
            <button class="text-resolution_blue w-full h-full text-right p-2 pr-5">MENTIONS LÉGALES</button>
            <LegalMentions />
        </div>
    </div>
</template>

<script>
    import SummaryBox from '@/components/SummaryBox';
    import LegalMentions from '@/components/LegalMentions';
    export default {
        name: 'Summary',
        components: { SummaryBox, LegalMentions },
        methods: {
            initComponentsForSummary() {
                let summary = this.$t('summary').getAll();
                summary.forEach((summary_el) => {
                    let component_name = summary_el.component;
                    Vue.component(component_name, require(`@/components/${component_name}.vue`).default);
                });
            },
            openModal() {
                $eventbus.$emit("modal-legal-mentions:show");
            }
        },
        
        created() {
            this.initComponentsForSummary();
        },
    };
</script>

<style scoped lang="scss">
    .summary {
        // min-height: calc(100vh - $header_height - $header_space);
        // margin-top: calc($header_height + $header_space);
        min-height: 100vh;
        .summary_menu {
            .max-w-screen-6xl {
                max-width: 2360px;
            }
            .summary_left_content,
            .summary_right_content {
                margin-bottom: $summary_line_height;
                p {
                    @apply text-right text-nandor;
                }
            }
            .summary_right_content {
                width: 7%;
            }
            .summary_left_content {
                width: 100%;
                @media (min-width: 768px) {
                    width: 7%;
                    padding-right: 0;
                }
                .summary_text {
                    margin: 1rem 0;
                    @media (min-width: 768px) {
                        margin: 0;
                        margin-bottom: $summary_line_height;
                    }
                }
                .summary_logo {
                    display: block;
                    margin-top: 0;
                    @media (min-width: 768px) {
                        display: none;
                        margin-top: $box_spacing;
                    }
                }
            }
            .summary_boxes {
                // @media (min-width: 768px) {
                //     padding-left: $box_spacing;
                // }
                z-index: 2;
            }
            .summary_lines {
                z-index: 1;
                height: $summary_line_height;
            }
        }
    }
</style>
